/** @format */
import { useRef } from 'react';
import { Autocomplete, Box, Chip, TextField, Tooltip } from '@mui/material';

function MultiSelectBox(props) {
  const {
    variant,
    selectedList,
    handleChange,
    handleClose,
    selectList,
    placeholder,
    selectAllHandler,
    width = '250px',
    multiple = true,
    disabled = false,
    loadingText = 'Loading...',
    getOptionDisabled = () => {},
  } = props;
  const searchInputRef = useRef();

  const limitTags = 1;

  return (
    <Box
      label="multiselect-wrapper"
      sx={{
        display: 'flex',
        gap: 1,
        width: { xs: '100%', sm: width },
      }}
    >
      <Autocomplete
        value={selectedList}
        options={selectList}
        onBlur={handleClose}
        onChange={(event, value, reason) => {
          if (reason === 'clear') {
            selectAllHandler(false);
          } else {
            searchInputRef?.current.focus();
            handleChange(event, value, reason);
          }
        }}
        getLimitTagsText={(more) => `+${selectedList.length - limitTags}`}
        loading={true}
        disableCloseOnSelect={multiple}
        multiple={multiple}
        limitTags={limitTags}
        loadingText={loadingText}
        clearText="Clear All"
        sx={{ width: '100%' }}
        disabled={disabled}
        getOptionDisabled={getOptionDisabled}
        slotProps={{
          popper: {
            placement: 'bottom-start',
            modifiers: [
              {
                name: 'flip',
                enabled: false,
              },
              {
                name: 'preventOverflow',
                enabled: true,
                options: {
                  altAxis: true,
                  altBoundary: true,
                  tether: true,
                  rootBoundary: 'viewport',
                },
              },
            ],
          },
        }}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          } else {
            const key = Object.keys(option)[0];
            return option[key] || '';
          }
        }}
        renderInput={(params) => (
          <TextField
            inputRef={searchInputRef}
            {...params}
            size="small"
            variant={variant || 'filled'}
            label={placeholder}
          />
        )}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          const label =
            typeof option === 'string'
              ? option
              : (() => {
                  const optKey = Object.keys(option)[0];
                  return option[optKey] || optKey || '';
                })();
          return (
            <li key={key} {...optionProps}>
              {label}
            </li>
          );
        }}
        renderTags={(options, getTagProps) => {
          options = options.slice(0, 4); // limit options array elements.
          return options.map((option, index) => {
            const { key, ...optionProps } = getTagProps({ index });
            let chipText = option;
            if (typeof option !== 'string') {
              chipText = Object.values(option)[0];
            }

            return (
              <Tooltip key={index} title={chipText}>
                <Chip
                  size="small"
                  {...optionProps}
                  label={
                    chipText?.length > 10
                      ? chipText?.slice(0, 7) + '..'
                      : chipText
                  }
                />
              </Tooltip>
            );
          });
        }}
      />
    </Box>
  );
}

export default MultiSelectBox;
